import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-560062ed")

_pushScopeId("data-v-560062ed")
const _hoisted_1 = /*#__PURE__*/_createVNode("h3", null, "着信一覧", -1)
const _hoisted_2 = { class: "card-list" }
const _hoisted_3 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_key_value_frame = _resolveComponent("key-value-frame")
  const _component_radio_button_card = _resolveComponent("radio-button-card")
  const _component_vue_y_scroll_area = _resolveComponent("vue-y-scroll-area")
  const _component_vue_content = _resolveComponent("vue-content")

  return (_openBlock(), _createBlock(_component_vue_content, { class: "vue-content-remain-child" }, {
    default: _withId(() => [
      _hoisted_1,
      _createVNode(_component_vue_y_scroll_area, null, {
        default: _withId(() => [
          _createVNode("div", _hoisted_2, [
            (_ctx.patientAnswers.length===0)
              ? (_openBlock(), _createBlock("div", _hoisted_3, "着信情報はありません"))
              : _createCommentVNode("", true),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.patientAnswers, (a) => {
              return (_openBlock(), _createBlock(_component_radio_button_card, {
                key: a.answer.id,
                selected: a.answer.id === _ctx.selectedAnswerId,
                onClick: ($event: any) => (_ctx.onSelectAnswer(a.answer.id, a.patient.private.phoneNumber || []))
              }, {
                default: _withId(() => [
                  _createVNode(_component_key_value_frame, {
                    class: "answer-list-content",
                    items: a.info
                  }, null, 8, ["items"])
                ]),
                _: 2
              }, 1032, ["selected", "onClick"]))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})